import React, { Component } from "react";
import "../Wizard/Wizard.css";
import { Step, StepContent, StepTitle, Button, ButtonProps } from "semantic-ui-react";

interface IProps {
  activeStep: number;
  maxActiveStep: number;
  onClick?(step: number): void;
}

interface IState {}

export class Wizard extends Component<IProps, IState> {

  handle = (step: number) => (e: React.MouseEvent<HTMLAnchorElement,MouseEvent>) => {

    e.preventDefault();
    e.stopPropagation();
    
    if (this.props.onClick) {
      this.props.onClick(step);
    }
  };

  render() {
    const { activeStep, maxActiveStep } = this.props;
    return (
      <Step.Group unstackable widths={3} size="small" fluid>
        <Step active={activeStep == 1} disabled={activeStep != 1} style={{pointerEvents: 'inherit',cursor:'pointer'}}>
          <Step.Content>
            <Step.Title>{ maxActiveStep >= 1 ? <a style={{textDecoration:'none'}} onClick={this.handle(1)}>Start</a> : "Start"}</Step.Title>
          </Step.Content>
        </Step>
        <Step active={activeStep == 2} disabled={activeStep != 2} style={{pointerEvents: 'inherit',cursor:'pointer'}}>
          <Step.Content>
          <Step.Title>{ maxActiveStep >= 2 ? <a style={{textDecoration:'none'}} onClick={this.handle(2)}>Cover</a> : "Cover"}</Step.Title>
          </Step.Content>
        </Step>
        <Step active={activeStep == 3} disabled={activeStep != 3}>
          <Step.Content>
          <Step.Title>Checkout</Step.Title>
          </Step.Content>
        </Step>
      </Step.Group>
    );
  }
}

export default Wizard;
